import React from 'react';

interface ExpandMoreIconProps {
  className?: string;
}

export const ExpandMoreIcon: React.FC<ExpandMoreIconProps> = ({ className }) => (
  <svg 
    className={className}
    width="12" 
    height="7" 
    viewBox="0 0 12 7" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
  >
    <path 
      fillRule="evenodd" 
      clipRule="evenodd" 
      d="M6.53033 6.77219C6.23744 7.07593 5.76256 7.07593 5.46967 6.77219L0.219671 1.32775C-0.0732227 1.02401 -0.0732226 0.531546 0.219671 0.227805C0.512563 -0.0759368 0.987438 -0.0759368 1.28033 0.227805L6 5.12228L10.7197 0.227806C11.0126 -0.0759359 11.4874 -0.0759359 11.7803 0.227806C12.0732 0.531547 12.0732 1.02401 11.7803 1.32775L6.53033 6.77219Z" 
      fill="#919192"
    />
  </svg>
); 